import selectPopShowOption from '../actions/selectPopShowOption';
import selectPopMessageSettingOption from '../actions/selectPopMessageSettingOption';
import PopOptionState from '../store/schema/PopOptionState';
import store from '../store/store';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import { getPopImapConfiguration } from 'owa-popimap-configuration';
import { PopImapConfigurationState } from 'owa-popimap-configuration';
import { getFallbackValueIfNull } from 'owa-options-core';
import { isConsumer } from 'owa-session-store';

const styles = require('./PopImapOption.scss');

export interface PopImapFullProps {
    optionStore?: PopOptionState;
}

const ENABLE = 'enable';
const DISABLE = 'disable';

@reactive({
    optionStore: () => store,
})
export default class PopImapFull extends React.Component<PopImapFullProps, {}> {
    render() {
        let popImapConfiguration: PopImapConfigurationState = getPopImapConfiguration();

        if (!popImapConfiguration) {
            return <Spinner />;
        }

        let { optionStore } = this.props;

        let popEnabled = getFallbackValueIfNull(
            optionStore.popEnabled,
            popImapConfiguration.popEnabled
        );
        let popMessageDeleteEnabled = getFallbackValueIfNull(
            optionStore.popMessageDeleteEnabled,
            popImapConfiguration.popMessageDeleteEnabled
        );
        let popSettings = popEnabled
            ? getFallbackValueIfNull(optionStore.popSettings, popImapConfiguration.popSettings)
            : strings.options_pop_messagesettingdisabledLabel;
        let imapSettings = getFallbackValueIfNull(
            optionStore.imapSettings,
            popImapConfiguration.imapSettings
        );
        let smtpSettings = getFallbackValueIfNull(
            optionStore.smtpSettings,
            popImapConfiguration.smtpSettings
        );

        return (
            <div>
                <div className={styles.settingContainer}>
                    <Label className={styles.settingHeader}>
                        {strings.options_pop_headerLabel}
                    </Label>
                    <ChoiceGroup
                        className={styles.popChoices}
                        selectedKey={popEnabled ? ENABLE : DISABLE}
                        label={strings.options_pop_toggleLabel}
                        options={[
                            {
                                key: ENABLE,
                                text: strings.options_pop_enabled,
                            },
                            {
                                key: DISABLE,
                                text: strings.options_pop_disabled,
                            },
                        ]}
                        onChange={this.onPopShowChange}
                        disabled={!isConsumer()}
                    />
                    {popEnabled && isConsumer() ? (
                        <ChoiceGroup
                            className={styles.popChoices}
                            selectedKey={popMessageDeleteEnabled ? ENABLE : DISABLE}
                            label={strings.options_pop_messagesettingLabel}
                            options={[
                                {
                                    key: DISABLE,
                                    text: strings.options_pop_dontallow,
                                },
                                {
                                    key: ENABLE,
                                    text: strings.options_pop_allow,
                                },
                            ]}
                            onChange={this.onPopMessageSettingChange}
                        />
                    ) : null}
                </div>
                <div className={styles.settingContainer}>
                    <Label className={styles.settingHeader}>
                        {strings.options_pop_messagesettingheaderLabel}
                    </Label>
                    <textarea className={styles.settingValue} value={popSettings} />
                </div>
                <div className={styles.settingContainer}>
                    <Label className={styles.settingHeader}>
                        {strings.options_imap_settingLabel}
                    </Label>
                    <textarea className={styles.settingValue} value={imapSettings} />
                </div>
                <div className={styles.settingContainer}>
                    <Label className={styles.settingHeader}>
                        {strings.options_smtp_settingLabel}
                    </Label>
                    <textarea className={styles.settingValue} value={smtpSettings} />
                </div>
            </div>
        );
    }

    private onPopShowChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        selectPopShowOption(option.key == ENABLE);
    };

    private onPopMessageSettingChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        selectPopMessageSettingOption(option.key == ENABLE);
    };
}
